import { render } from "./SincronizarAmbientesIndex.vue?vue&type=template&id=1eac1b68&scoped=true&ts=true"
import script from "./SincronizarAmbientesIndex.vue?vue&type=script&lang=ts"
export * from "./SincronizarAmbientesIndex.vue?vue&type=script&lang=ts"

import "./SincronizarAmbientesIndex.vue?vue&type=style&index=0&id=1eac1b68&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eac1b68"]])

export default __exports__